import { tempoApi } from '../tempoApi';
import type { Box, CreateBoxRequest, PaginatedBoxResponse, PatchBoxRequest } from '../types/boxes';
import { buildBoxesURLSearchParams } from './utils/searchParamBuilders';

const getBoxes = async ({
  cursor = '',
  filter,
  order,
  limit,
}: {
  cursor?: string;
  filter?: string;
  order?: string;
  limit?: number;
}) => {
  return await tempoApi()
    .get(`api/v1/item-store/boxes${buildBoxesURLSearchParams({ cursor, filter, order, limit })}`)
    .json<PaginatedBoxResponse>();
};

const createBox = async ({ data }: { data: CreateBoxRequest }) =>
  await tempoApi().post('api/v1/item-store/boxes', { json: data }).json<Box>();

const patchBox = async ({
  boxId,
  data,
}: {
  boxId: number;
  data: PatchBoxRequest;
}): Promise<Box> => {
  return await tempoApi()
    .patch(`api/v1/item-store/boxes/${boxId}`, {
      json: data,
    })
    .json<Box>();
};

const getAllBoxes = async (): Promise<Box[]> => {
  const boxes: Box[] = [];
  let cursor = '';

  do {
    const page = await getBoxes({ cursor, limit: 1000 });
    boxes.push(...page.data);
    cursor = page.cursor ?? '';
  } while (cursor);

  return boxes;
};

const getBox = async (boxId: number): Promise<Box> => {
  return await tempoApi().get(`api/v1/item-store/boxes/${boxId}`).json<Box>();
};

const deleteBox = async ({ boxId }: { boxId: number }): Promise<void> => {
  await tempoApi().delete(`api/v1/item-store/boxes/${boxId}`);
};

export const BoxesApi = {
  getBoxes,
  getAllBoxes,
  getBox,
  createBox,
  patchBox,
  deleteBox,
} as const;
